// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'

import './assets/font/font.css'
import animated from 'animate.css' // npm install animate.css --save安装，再引入

// GEO 整改 - SEO 工具
import { setJsonLd, clearJsonLd, SITE_ORIGIN } from './untils/seo'

Vue.use(animated)
axios.defaults.responseType = 'json';
import axios from 'axios'
Vue.use(ElementUI)
axios.defaults.baseURL='https://api.smalleel.com/platform-cloud-manage'
// axios.defaults.baseURL='http://192.168.2.233:18015/platform-cloud-manage'
// axios.defaults.baseURL='https://test.cloudapi.smalleel.com/platform-cloud-manage'


// 站点主域名(GEO规范化使用)
const _SITE_ORIGIN = SITE_ORIGIN

// 工具:设置/更新 head 中的 <link rel="canonical">
function setCanonical(href) {
  let link = document.querySelector('link[rel="canonical"]')
  if (!link) {
    link = document.createElement('link')
    link.setAttribute('rel', 'canonical')
    document.head.appendChild(link)
  }
  link.setAttribute('href', href)
}

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面meta */
  if (to.meta.content) {
    let head = document.getElementsByTagName('head')
    let meta = document.createElement('meta')
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content
    head[0].appendChild(meta)
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }

  /* Canonical 规范标签 - self-canonical */
  setCanonical(_SITE_ORIGIN + to.path)

  /* 面包屑 - 如果路由 meta 中配置了 breadcrumb,则自动注入 */
  if (to.meta.breadcrumb && Array.isArray(to.meta.breadcrumb) && to.meta.breadcrumb.length) {
    setJsonLd('breadcrumb', {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      'itemListElement': to.meta.breadcrumb.map((item, index) => ({
        '@type': 'ListItem',
        'position': index + 1,
        'name': item.name,
        'item': _SITE_ORIGIN + item.url
      }))
    })
  } else {
    clearJsonLd('breadcrumb')
  }

  /* 通用列表页 WebPage 结构化数据 */
  if (to.meta.webpage) {
    const wp = to.meta.webpage
    setJsonLd('webpage', {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': wp.id || (_SITE_ORIGIN + to.path + '#page'),
      'name': wp.name,
      'description': wp.description,
      'url': wp.url || (_SITE_ORIGIN + to.path),
      'inLanguage': 'zh-CN',
      'isPartOf': {
        '@type': 'WebSite',
        '@id': _SITE_ORIGIN + '/#website',
        'name': '辰鳗科技集团-小鳗管家',
        'url': _SITE_ORIGIN + '/'
      },
      'breadcrumb': to.meta.breadcrumb ? {
        '@type': 'BreadcrumbList',
        'itemListElement': to.meta.breadcrumb.map((item, index) => ({
          '@type': 'ListItem',
          'position': index + 1,
          'name': item.name,
          'item': _SITE_ORIGIN + item.url
        }))
      } : undefined
    })
  } else {
    clearJsonLd('webpage')
  }

  /* 列表型 ItemList(产品列表、解决方案列表) */
  if (to.meta.itemlist) {
    const il = to.meta.itemlist
    setJsonLd('itemlist', {
      '@context': 'https://schema.org',
      '@type': ['WebPage', 'ItemList'],
      '@id': il.id || (_SITE_ORIGIN + to.path + '#page'),
      'name': il.name,
      'description': il.description,
      'url': il.url || (_SITE_ORIGIN + to.path),
      'numberOfItems': il.items ? il.items.length : 0,
      'mainEntityOfPage': {
        '@type': 'WebPage',
        '@id': il.url || (_SITE_ORIGIN + to.path)
      },
      'itemListElement': (il.items || []).map((item, index) => ({
        '@type': 'ListItem',
        'position': index + 1,
        'item': {
          '@type': item.type || 'Service',
          'name': item.name,
          'description': item.description,
          'url': item.url,
          'image': item.image
        }
      })),
      'breadcrumb': to.meta.breadcrumb ? {
        '@type': 'BreadcrumbList',
        'itemListElement': to.meta.breadcrumb.map((item, index) => ({
          '@type': 'ListItem',
          'position': index + 1,
          'name': item.name,
          'item': _SITE_ORIGIN + item.url
        }))
      } : undefined
    })
  } else {
    clearJsonLd('itemlist')
  }

  /* 每页清理旧的结构化数据,后续由各页面 mounted 时按需注入 */
  clearJsonLd('webpage')
  clearJsonLd('article')
  clearJsonLd('product')
  clearJsonLd('itemlist')
  clearJsonLd('faq')
  // 首页 Organization 保留(单实例)
  if (to.path !== '/') {
    clearJsonLd('organization')
  }

  next()
})


Vue.prototype.$axios = axios
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js